import { render, staticRenderFns } from "./CopyrightAssignmentTransferTab.vue?vue&type=template&id=3d59961c&scoped=true&"
import script from "./CopyrightAssignmentTransferTab.vue?vue&type=script&lang=js&"
export * from "./CopyrightAssignmentTransferTab.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAssignmentTransferTab.vue?vue&type=style&index=0&id=3d59961c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d59961c",
  null
  
)

export default component.exports